import { render, staticRenderFns } from "./CuentaEdit.vue?vue&type=template&id=52fbc942&scoped=true"
import script from "./CuentaEdit.vue?vue&type=script&lang=js"
export * from "./CuentaEdit.vue?vue&type=script&lang=js"
import style0 from "./CuentaEdit.vue?vue&type=style&index=0&id=52fbc942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fbc942",
  null
  
)

export default component.exports